<div class="dropdown">
  @if (label) {
    <span class="dropdown-label">{{ label }}</span>
  }
  <button
    class="dropdown-trigger"
    [class.dropdown-trigger--open]="isOpen()"
    [class.dropdown-trigger--static]="disabled && !isSaving"
    (click)="toggle()"
    type="button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    [disabled]="isSaving || disabled"
  >
    <span class="dropdown-value" [class.dropdown-value--placeholder]="!triggerValue">
      {{ triggerValue ?? placeholder }}
    </span>
  </button>

  @if (isOpen()) {
    <div class="dropdown-panel" role="listbox">
      @if (isLoading) {
        <div class="dropdown-state">Loading…</div>
      } @else if (loadError) {
        <div class="dropdown-state dropdown-state--error">{{ loadErrorMessage }}</div>
      } @else if (items.length === 0) {
        <div class="dropdown-state">{{ emptyMessage }}</div>
      } @else {
        @for (item of items; track (itemId ? itemId(item) : $index)) {
          <button
            class="dropdown-option"
            [class.dropdown-option--selected]="isSelected(item)"
            (click)="select(item)"
            [disabled]="isSaving"
            type="button"
            role="option"
            [attr.aria-selected]="isSelected(item)"
          >
            @if (itemTemplate) {
              <ng-container
                [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ $implicit: item }"
              ></ng-container>
            } @else {
              {{ item }}
            }
          </button>
        }
      }
      @if (saveError) {
        <div class="dropdown-state dropdown-state--error">{{ saveErrorMessage }}</div>
      }
    </div>
  }
</div>
